export default async function useValidateDynamicForms(ctx) {
  let isValid = true
  const { refs } = ctx

  const promises = Object.keys(refs).map(async refKey => {
    if (refs[refKey].length) {
      const valid = await refs[refKey][0].validate()
      if (!valid) isValid = false
    }
  })
  await Promise.all(promises)
  return isValid
}
